'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _pullout = require('../../../pullout');

var _pullout2 = _interopRequireDefault(_pullout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VideoButton = function (_React$Component) {
  _inherits(VideoButton, _React$Component);

  function VideoButton() {
    _classCallCheck(this, VideoButton);

    return _possibleConstructorReturn(this, (VideoButton.__proto__ || Object.getPrototypeOf(VideoButton)).apply(this, arguments));
  }

  _createClass(VideoButton, [{
    key: 'render',
    value: function render() {
      var filteredProps = {
        config: {
          appBadge: false,
          textAlign: 'center',
          theme: this.props.config.theme,
          id: this.props.config.id
        },
        content: {
          headline: {
            text: this.props.content.headline.text
          }
        }
      };

      if (this.props.content.mediaButton) {
        var mediaButtonObj = JSON.parse(JSON.stringify(this.props.content.mediaButton));
        mediaButtonObj.fpti = 'VidBtn-MediaBtn-' + this.props.content.mediaButton.text;
        filteredProps.content.mediaButton = mediaButtonObj;
      }
      if (this.props.config.isLongHeadline) {
        filteredProps.config.isLongHeadline = this.props.config.isLongHeadline;
      }
      if (this.props.className) {
        filteredProps.className = this.props.className;
      }

      return _react2.default.createElement(_pullout2.default, filteredProps);
    }
  }]);

  return VideoButton;
}(_react2.default.Component);

exports.default = VideoButton;


VideoButton.propTypes = {
  config: _propTypes2.default.shape({
    theme: _propTypes2.default.oneOf(['theme-background-color-white', 'theme-background-color-light']).isRequired,
    isLongHeadline: _propTypes2.default.bool,
    id: _propTypes2.default.string
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    mediaButton: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      href: _propTypes2.default.string,
      text: _propTypes2.default.string.isRequired,
      'data-video-id': _propTypes2.default.string.isRequired
    }).isRequired
  }),
  className: _propTypes2.default.string
};

VideoButton.defaultProps = {
  config: {
    appBadge: false,
    textAlign: 'center',
    theme: 'theme-background-color-white',
    isLongHeadline: false,
    id: ''
  },
  content: {
    headline: {
      text: 'Fewer than 25 characters fit on one line in mobile.'
    },
    mediaButton: {
      id: '',
      href: '#',
      text: 'Fewer Than 29 Characters',
      'data-video-id': 'lkz4GZgyb9o'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/pullout/video-button/jsx/VideoButton.js
// module id = 1137
// module chunks = 4